export default "__VITE_ASSET__CrsnS$QR__"